module.exports = __webpack_public_path__ + "img/physicalsecurity-2016-rounded_v1-500x500-1.fcd36228.png";